import './video-workspace.component.ajscss';

import { AppExternalService } from '@commons/core/ui/app-external.service';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './video-workspace.component.ajs.html';

class VideoWorkspaceCtrl implements IComponentController {
  responseId: string;

  constructor(private readonly externalApplicationsService: AppExternalService) {}

  $postLink(): void {
    this.positionFrame();
    this.showFrame();
  }

  $onDestroy(): void {
    this.hideFrame();
  }

  private showFrame(): void {
    this.externalApplicationsService.showApplication('vcFrame');
  }

  private hideFrame(): void {
    this.externalApplicationsService.hideApplication('vcFrame');
  }

  private positionFrame(): void {
    const container = document.getElementById('Area-WorkZone');
    if (container) {
      this.externalApplicationsService.positionApplication('vcFrame', container);
    }
  }
}

export class VideoWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = ['externalApplications', VideoWorkspaceCtrl];
}

export default 'contactVideoWorkspace';
